module.exports = __webpack_public_path__ + "img/jl_xx@2x.80743eb6.png";